import {Dropdown, DropdownChangeParams} from 'primereact/dropdown'
import React from 'react'

export const getMonthNavigatorTemplate = (navigatorOptions: any): JSX.Element =>
	<Dropdown
		value={navigatorOptions.value}
		appendTo={document.body}
		options={navigatorOptions.options}
		onChange={(event: DropdownChangeParams) => navigatorOptions.onChange(event.originalEvent, event.value)}
		style={{lineHeight: 1}}
		className={'mr-2 pl-3'}
	/>

export const getYearNavigatorTemplate = (navigatorOptions: any): JSX.Element => {
	return <Dropdown
		appendTo={document.body}
		value={navigatorOptions.value}
		options={navigatorOptions.options}
		onChange={(event: DropdownChangeParams) => navigatorOptions.onChange(event.originalEvent, event.value)}
		style={{lineHeight: 1}}
		className={'pl-3'}
	/>
}

// We want the actual year to add relatives like siblings or children born this year
export const getBirthDayYearRange = (): string => {
	const startDate = '1945'
	const currentYear = new Date().getFullYear()
	return startDate + ':' + currentYear
}

export const getApprenticeShipYearRange = (): string => {
	const startDate = '2012'

	const currentYear = new Date().getFullYear()
	return startDate + ':' + (currentYear + 8)
}